import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { pbdqColors } from '../theme/pbdqTokens';

// A single AI message bubble in the DQ Agent chat panel (Chatbot page).
// Unlike PbdqChatUserMessage, this bubble's background never used to pair
// with an explicit text color — it inherited whatever the app's ambient
// light/dark mode preference set on <body>, so a visitor whose color mode
// was "dark" (e.g. from the internal DQ Pro dashboard, which does support
// dark mode) got near-white inherited text on this bubble's always-light
// background, since the public Powered by DQ site has no dark mode at all.
const useStyles = makeStyles(() => ({
    bubble: {
        maxWidth: 432,
        background: pbdqColors.neutral100,
        color: pbdqColors.text,
        padding: '14px 18px',
        fontSize: 14.5,
        lineHeight: '23px',
        justifySelf: 'start',
        margin: 0,
        borderRadius: 14,
    },
}));

const PbdqChatMessage = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.bubble}>{children}</div>;
};

export default PbdqChatMessage;
